<template>
  <div v-if="isLoad" class="m-index">
    <TopBar :type="1" :logo="logo" />
    <!-- banner图&图标跳转 -->
    <div class="banner_cont" v-if="bannerList.length>0">
      <div class="swiper_cont">
        <swiper class="m-banner" ref="bannerSwiper" :options="swiperOptionsBanner" v-if="bannerList.length">
            <swiper-slide v-for="(item, index) in bannerList" :key="item.image + '_' + index">
            <img v-if="!item.link" class="banner-img" :src="item.image" />
            <a :href="item.link" v-else>
              <img class="banner-img" :src="item.image" />
            </a>
            </swiper-slide>
        </swiper>
      </div>
      <div class="menu" v-if="menuList && menuList.length > 0">
        <div
          v-for="menu in menuList"
          :key="menu.name"
          class="menu-link"
          @click="menuJump(menu.url)"
        >
          <img :src="menu.icon" class="menu-img" />
          <p class="menu-title">{{ menu.name }}</p>
        </div>
      </div>
    </div>
    <!-- 直播 -->
    <div class="modal-content live" v-if="liveModule.length > 0">
      <div class="title_cont_info flex">
        <p class="text"><img class="zb-title-img" src="@/assets/m/zgwt/zbtitle.png" alt="直播课堂" /></p>
      </div>
      <swiper class="live-swiper" ref="liveSwiper" :options="swiperOptionsLive">
        <swiper-slide v-for="item in liveModule" :key="item.id">
          <div class="live-slide-content" @click="selectLive(item)">
            <div class="live-banner">
              <img class="live-banner-img" :src="item.mobile_image" />
            </div>
            <div class="live-bottom-info">
              <div class="live-status">
                <span v-if="item.liveNow" class="live-status-icon"></span>
                <span
                  class="live-status-text"
                  :class="item.liveNow ? 'is-live' : 'is-not-live'"
                >
                  {{ item.liveNow ? "正在直播" : "即将直播" }}
                </span>
                <span class="live-status-time">{{ item.live_date }}</span>
              </div>
              <div class="live-course-title">{{ item.name }}</div>
              <div class="live-lecturer-name">主讲人：{{ item.teacher_name }}</div>
            </div>
          </div>
        </swiper-slide>
      </swiper>
      <div class="flex-center">
        <div class="more_btn flex" @click="$router.push('liveList')">
          <span>查看更多</span>
          <img src="@/assets/m/zgwt/right_icon.png" alt="">
        </div>
      </div>
    </div>
    <div class="container_cont_data">
      
      <div class="cont_box">
        <!-- 创新思维与方法 -->
        <div class="cont_item cont1">
          <div class="title_cont_info flex">
            <p class="text"><img class="zg-title-img" src="@/assets/m/zgwt/zgtitle.png" alt="" /></p>
          </div>
          <div class="tab_cont_list">
              <ul>
                  <li
                  class="cursor"
                  v-for="(item, index) in moduleList1"
                  :key="item.id"
                  :class="(modalId1 ? modalId1 == item.id : index == 0) ? 'active' : ''"
                  @click="changModal(item.id,'1')"
                  >
                  {{ item.name }}
                  </li>
              </ul>
          </div>
          <div class="course_list">
              <ul>
                  <li v-for="item in courseList1" :key="item.id" @click="goCourseDetail(item)">
                      <p class="img"><img :src="item.image" alt=""></p>
                      <p class="text overflow_e">{{ item.name }}</p>
                  </li>
              </ul>
          </div>
          <div class="flex-center">
            <div class="more_btn flex" v-if="siteInfo&&siteInfo.id&&siteInfo.id==73"  @click="goNewUrl('https://npx.kskstudy.com/')">
              <span>查看更多</span>
              <img src="@/assets/m/zgwt/right_icon.png" alt="">
            </div>
            <div class="more_btn flex" v-else  @click="$router.push('/courseList')">
              <span>查看更多</span>
              <img src="@/assets/m/zgwt/right_icon.png" alt="">
            </div>
          </div>
        </div>
        <!-- 大师来了 -->
        <div class="jx-teacher-bg">
          <div class="title_cont_info flex">
            <p class="text"><img class="jx-title-img" src="@/assets/zgwt/jxtitle.png" alt="匠星名师" /></p>
          </div>
          <div v-if="teacherList.length>0">
            <div v-for="(item, index) in teacherList" :key="index" class="teacher_cont_box">
              <div class="teacher_list_cont">
                  <swiper class="teacherSwiper" ref="bannerSwiper" :options="teacherOptions" v-if="item.length">
                      <swiper-slide class="slide_item" v-for="(i) in item" :key="i.id">
                        <div class="jx-teacher-slide">
                          <div class="jx-teacher-card">
                            <div class="jx-teacher-card-top">
                              <div class="jx-teacher-avatar">
                                <img v-if="i.remark" :src="i.remark" alt="" />
                                <img v-else :src="i.avatar" alt="" />
                              </div>
                              <div class="jx-teacher-title">
                                <p class="jx-teacher-name">{{ i.name }}</p>
                              </div>
                            </div>
                            <div class="jx-teacher-card-bottom">
                              <div class="jx-teacher-desc">{{ i.introduce }}</div>
                            </div>
                          </div>
                          
                        </div>
                      </swiper-slide>
                      
                  </swiper>
                  <div class="jx-more-btn flex" @click="$router.push('/lecturer')">
                    <span>查看更多</span>
                    <img class="jx-more-arrow" src="@/assets/m/zgwt/right_icon.png" alt="" />
                  </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 创新工作室-工作室解读 -->
        <div class="cont_item cont2" v-for="(item, index) in contDataInfo" :key="item.id" :class="item.id == 503 ? 'wdy_bg' : item.id == 504 ? 'news_bg' : item.id == 510 ? 'yx_bg' : ''">
          <div>
            <div class="title_cont_info flex">
                <p class="text">
                  <img v-if="item.id == 503" class="wdy-title-img" src="@/assets/m/zgwt/wdytitle.png" alt="" />
                  <img v-else-if="item.id == 504" class="xw-title-img" src="@/assets/m/zgwt/xwtitle.png" alt="" />
                  <img v-else-if="item.id == 510" class="yx-title-img" src="@/assets/m/zgwt/yxtitle.png" alt="" />
                  <span v-else>{{item.name}}</span>
                </p>
            </div>
            <div class="course_cont_list">
              <ul>
                <li v-for="list in item.list" :key="list.id" @click="item.style_id != 6 ? goBox3Detail(list) : goBoxDetail(list)">
                  <div class="course_cont_item">
                    <p class="img"><img :src="list.image" alt=""></p>
                    <div class="info_cont">
                      <p class="text overflow_1">{{list.name}}</p>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div class="vert_box" v-if="advertList[index]">
                <div class="advert_image">
                <a :href="advertList[index].m_link">
                    <img :src="advertList[index].m_image" />
                </a>
                </div>
            </div>
            <div class="flex-center">
              <div v-if="item.style_id != 6" class="more_btn flex" @click="$router.push('/activeList/' + item.id + '/' + item.name)">
                  <span>查看更多</span>
                  <img src="@/assets/m/zgwt/right_icon.png" alt="">
              </div>
            </div>
          </div>
        </div>

       <!-- 公开班级 -->
       <div class="gk-section" v-if="openClassList.length > 0">
         <div class="gk-title">
           <img class="gk-title-img" src="@/assets/m/zgwt/gktitle.png" alt="" />
         </div>
         <div class="gk-grid">
           <div
             class="gk-card"
             v-for="examItem in openClassList"
             :key="examItem.id"
             @click="sightBtn(examItem.id)"
           >
             <div class="gk-card-top">
               <img class="gk-card-img" :src="examItem.image" alt="" />
               <!-- <div class="gk-card-title">{{ examItem.name }}</div> -->
             </div>
             <div class="gk-card-body">
               <div class="gk-row">
                 <span class="gk-label">开始时间：</span>
                 <span class="gk-value">{{ examItem.start_date }}</span>
               </div>
               <div class="gk-row">
                 <span class="gk-label">结束时间：</span>
                 <span class="gk-value">{{ examItem.end_date }}</span>
               </div>
               <div class="gk-status" :class="getGkStatusClass(examItem)">
                 {{ getGkStatusText(examItem) }}
               </div>
               <div class="gk-foot">{{ examItem.name }}</div>
             </div>
           </div>
         </div>
       </div>
      </div>
      <div class="cont_item cont1" v-if="moduleList2.length>0">
          <div class="tab_cont_list">
            <ul>
              <li class="cursor" v-for="item in moduleList2" :key="item.id" :class="modalId2 == item.id ? 'active' : ''" @click="changModal(item.id,'2')">
                {{ item.name }}
              </li>
            </ul>
          </div>
          <div class="course_list">
            <ul>
              <li v-for="item in courseList2" :key="item.id" @click="goCourseDetail(item)">
                <p class="img"><img :src="item.image" alt=""></p>
                <p class="text overflow_e">{{ item.name }}</p>
              </li>
            </ul>
        </div>
      </div>
        <a href="https://www.wjx.cn/vm/hiRVLgn.aspx#" target="_blank" v-if="siteInfo&&siteInfo.id&&siteInfo.id==73">
        <div class="line_img">
          <img src="@/assets/m/newIndex/line_img1.png" alt="">
        </div>
      </a>
      <a href="https://www.wjx.cn/vm/hiRVLgn.aspx#" target="_blank" v-if="siteInfo&&siteInfo.id&&siteInfo.id==73">
        <div class="line_img last_img">
          <img src="@/assets/m/newIndex/line_img2.png" alt="">
        </div>
      </a>
    </div>

    <!-- 公开考试 -->
    <div class="modal-content comm-exam-cont" v-if="commonExamList.length > 0">
      <div class="modal-title">
        <span>考试练兵</span>
        <router-link to="/commonExam/list" class="more">更多</router-link>
      </div>
      <ul class="xilie-list">
        <li v-for="examItem in commonExamList" :key="examItem.id">
          <p class="exam_name">{{ examItem.exam_name }}</p>
          <div class="time_">
            <p>开始时间：{{ examItem.start_date }}</p>
            <p>结束时间：{{ examItem.end_date }}</p>
          </div>
          <div class="down_num">限制考试次数：{{ examItem.limit_desc }}</div>
          <div
            class="btn"
            @click="$router.push('/commonExam/text/' + examItem.id)"
          >
            去考试
          </div>
        </li>
      </ul>
    </div>
    <!-- <div class="deep_cont_box">
      <p class="support">技术支持：中工科创</p>
      <p class="copyright">Copyright © 2023-{{ new Date().getFullYear() }} kskstudy.com</p>
      <p class="rights">All Rights Reserved</p>
      <p class="icp">京ICP备16012224号</p>
    </div> -->
     <BottomWtxhM />
  </div>
</template>
<script>
import { mapMutations } from "vuex";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import TopBar from "@/m/common/topBar.vue";
import { stringify } from 'qs';
import BottomWtxhM from "@/m/common/bottomWtxhM.vue";

export default {
  name: "Index",
  components: {
    TopBar,
    Swiper,
    SwiperSlide,
    BottomWtxhM
  },
  data() {
    return {
      logo: "",
      bannerList: [],
      moduleList:[],//创新思维与创新方法 分类
      moduleList1:[],//创新思维与创新方法 分类
      moduleList2:[],//创新思维与创新方法 分类
      modalId1:'',
      modalId2:'',
      courseList1:[],//创新思维与创新方法
      courseList2:[],//创新思维与创新方法
      teacherList:[],//大师来了
      showTeacher:'',//当前显示讲师
      contDataInfo:[],
      commonExamList: [], //公开考试列表
      //banner
      swiperOptionsBanner: {
        slidesPerView: 1, //显示slide的数量
        centeredSlides: true, //居中显示
        spaceBetween: 14, //间距
        loop: true, //循环
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: true,
        },
        //setWrapperSize :true,  // Swiper使用flexbox布局(display: flex)，
        pagination: {
          el: ".swiper-pagination",
          clickable: true, //是否可点击
        },
      },
      siteInfo:'',
        //   讲师轮播图
      teacherOptions:{
        slidesPerView: 1, //显示slide的数量
        centeredSlides: true, //居中显示
        spaceBetween: 0, //间距
        loop: true, //循环
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        autoplay: {
        delay: 300000,
        stopOnLastSlide: false,
        disableOnInteraction: true,
        },
       },
       //直播滚动
        swiperOptionsLive: {
            slidesPerView: 1, //一屏显示一个
            spaceBetween: 0, //间距
            centeredSlides: true, //居中显示
            loop: true, //循环
            observer: true, //修改swiper自己或子元素时，自动初始化swiper
            observeParents: true, //修改swiper的父元素时，自动初始化swiper
            autoplay: {
            delay: 4000,
            stopOnLastSlide: false,
            disableOnInteraction: true,
            },
        },
        //讲师
        lecturerOptionsLive: {
            slidesPerView: 1.1, //显示slide的数量
            spaceBetween: 24, //间距
            observer: true, //修改swiper自己或子元素时，自动初始化swiper
            observeParents: true, //修改swiper的父元素时，自动初始化swiper
            autoplay: {
            delay: 2000,
            stopOnLastSlide: false,
            disableOnInteraction: true,
            },
            loop: true,
        },
      showText:'职工课堂',
      liveModule: [], //直播模块
      liveSelect: [],
      advertList: [],
      comAuth: false,
      // 判断是否让页面加载
      isLoad: false,
      areaList: [], // 市县列表
      menuList: [],
      openClassList: []
    };
  },
  metaInfo() {
    return {
      meta: [
        // { name: "keywords", content: this.setting.keywords },
        // { name: "description", content: this.setting.description },
      ],
    };
  },
  created() {
    this.getWebsiteInfo(); //获取网站信息
  },
  mounted() {
    this.showText = '职工课堂'
    this.siteInfo = localStorage.getItem('siteInfo')? JSON.parse(localStorage.getItem('siteInfo')):''
    this.getBanner();
    this.getModule(); //获取首页模块
    this.getLliveModule(); //获取黔南州工匠大讲堂
    this.getAdvert(); //获取广告条
    this.getOpenExam(); //获取公开考试列表
    this.getareaList() // 市县列表
    this.getopenClassList()
    this.websiteData = this.$store.state.websiteState;
    //微信登录
    if (this.$route.query.noncestr) {
      this.weLoin(this.$route.query.noncestr);
    }
  },
  methods: {
    ...mapMutations(["ShowMLoginModal", "ShowTipModal", "CloseTipModal"]), //登录弹窗
    getopenClassList () {
      // 开放式班级
      this.$axios
        .post(`/v1/openClass/list`, { page: "1", per_page: "4" })
        .then((res) => {
          if (res.code == 0) {
            this.openClassList = res.data.data;
          }
        });
    },
     sightBtn(id) {
      let _this = this;
      _this.ShowTipModal({
        text: "确定报名该班级？", //提示弹窗内容
        showBtns: true,
        subBtnText: "报名",
        confirmFun: function () {
          _this.CloseTipModal();
          // _this.payNowBtn(_this.courseInfo.detail.id);
          this.$axios
            .post(
              `/v1/openClass/joinOpenClass`,
              { class_id: id },
              { useLog: true }
            )
            .then((res) => {
              _this.ShowTipModal({
                text: res.msg, //提示弹窗内容
              });
            });
        },
      });
    },
    // 市县列表
    getareaList() {
      this.$axios
        .post(`/v1/qn/areaList`, {})
        .then((res) => {
          if (res.code == 0) {
            this.areaList = res.data;
          }
        });
    },
    // 贵人家园登录
    logBtnGrjy() {
			if (this.bottomInfo.id == 106) {
				this.$axios.post(`/v1/gzLoginUrl`).then(res => {
					if(res.code == 0){
						window.location.href = res.data;
						localStorage.setItem('mLoginUrl', res.data);
            this.comAuth = true
					}else{
						this.ShowTipModal({
							text: res.msg,     //提示弹窗内容
						})
					}
				})
			}
    },
    //选择直播
    selectLive(data) {
      if (this.comAuth) {
        this.$router.push('/live/' + data.channel_no +'/'+ data.id)
      } else {
        this.$message({
          message: '请登录后操作',
          type: 'warning'
        });
      }
      // this.liveSelect = data;
    },
    getChannelNo() {
      this.$router.push(
        "/live/" + this.liveSelect.channel_no + "/" + this.liveSelect.id
      );
    },
    //获取黔南州工匠大讲堂
    getLliveModule() {
      this.$axios.post(`/v1/home/liveModule`).then((res) => {
        let nowDta = Date.now() / 1000;

        for (let i = 0; i < res.data.length; i++) {
          if (nowDta > res.data[i].live_time && nowDta < res.data[i].end_time) {
            res.data[i].liveNow = true;
          } else {
            res.data[i].liveNow = false;
          }
        }

        this.liveModule = res.data;
        this.liveSelect = res.data[0];
      });
    },
    // 获取有数据的头部
    async getHeadData(moduleData) {
      this.modulelist = moduleData;
      this.moduleList1 = [];
      if (this.modulelist <= 0) {
        this.loadState = false;
        setTimeout(() => {
          this.loadState1 = false;
        }, 1000);
      }
      for (let i = 0; i < moduleData.length; i++) {
        let res = await this.$axios.post(`/v1/home/moduleData`, {
          id: moduleData[i].id,
        });

        for (let i = 0; i < this.modulelist.length; i++) {
          if (res.data.total) {
            for (let o = 0; o < res.data.data.length; o++) {
              if (res.data.data[o].module_id == this.modulelist[i].id) {
                if (this.modulelist[i].list) {
                  this.$set(this.modulelist[i].list, o, res.data.data[o]);
                } else {
                  this.$set(this.modulelist[i], "list", []);
                  this.$set(this.modulelist[i].list, o, res.data.data[o]);
                }
              }
            }
          } else {
            for (let o = 0; o < res.data.length; o++) {
              if (res.data[o].module_id == this.modulelist[i].id) {
                if (this.modulelist[i].list) {
                  this.$set(this.modulelist[i].list, o, res.data[o]);
                } else {
                  this.$set(this.modulelist[i], "list", []);
                  this.$set(this.modulelist[i].list, o, res.data[o]);
                }
              }
            }
          }
        }
      }
      this.moduleList1 = this.modulelist.filter((item) => item.list);
      if (this.moduleList1 && this.moduleList1.length > 0) {
        const stillExists = this.moduleList1.some((m) => m.id == this.modalId1);
        if (!this.modalId1 || !stillExists) {
          this.modalId1 = this.moduleList1[0].id;
          this.getCourseList(this.modalId1, "1");
        }
      }
    },
    // 获取广告条
    getAdvert() {
      this.$axios
        .post(`/v1/home/advert`, {
          type: "1",
        })
        .then((res) => {
          if (res.code == 0) {
            this.advertList = res.data;
          }
        });
    },
     // 获取公开考试
    getOpenExam() {
      this.$axios
        .post(`/v1/commonExam/list`, { page: 1, per_page: 4 })
        .then((res) => {
          if (res.code == 0) {
            this.commonExamList = res.data.data;
          }
        });
    },
    parseGkDate(dateStr) {
      if (!dateStr) return null;
      const normalized = String(dateStr).replace(/-/g, "/");
      const date = new Date(normalized);
      if (isNaN(date.getTime())) return null;
      return date;
    },
    getGkStatusText(examItem) {
      const now = new Date();
      const start = this.parseGkDate(examItem && examItem.start_date);
      const end = this.parseGkDate(examItem && examItem.end_date);
      if (start && now < start) return "未开始";
      if (end && now > end) return "已结束";
      return "进行中";
    },
    getGkStatusClass(examItem) {
      const status = this.getGkStatusText(examItem);
      if (status === "未开始") return "is-wait";
      if (status === "已结束") return "is-end";
      return "is-going";
    },
    changModal(item,num){
      if(num==1){
        this.modalId1=item
      }else{
        this.modalId2 = item
      }
        this.getCourseList(item,num)
    },
    goCourseDetail(item){
        this.$router.push('/newRecordedInfo/'+item.data_id)
    },

    goBox3Detail(item){
      // if(item.pc_link){
      //   window.open(item.pc_link)
      // }
      // if (item.data_id == 204) {
      //     console.log(1);
      // } else {
        if (item.pc_link) {
          window.open(item.pc_link);
        } else {
          this.$router.push('/activeInfo/'+ item.data_id);
        }
      // }
    },
    goBoxDetail(val) {
      // this.$router.push('/countyCityZone/advicePage?id=' + val.data_id)
    },
    goNewUrl(url){
        window.open(url)
    },
    //菜单跳转
    menuJump(url) {
      if (url.includes("http")) {
        window.location.href = url;
      } else {
        if(url=='/getCert'){
          this.routerBtn()
        }else{
          this.$router.push(url);
        }
        
      }
    },
    // 获取banner图
    getBanner() {
      this.$axios
        .post(`/v1/home/banner`, {
          type: "2",
        })
        .then((res) => {
          if (res.data.length == 1) {
            this.swiperOptionsBanner.loop = false;
          }
          this.bannerList = res.data;
        });
    },
    //获取首页模块
    getModule() {
      this.$axios.post(`/v1/home/module`).then((res) => {
        if(res.code==0){
            let contBox3 = []
            let ids = []
            res.data.forEach(el=>{
                if(el.type==1){
                    this.moduleList.push(el)
                }
                if(el.type==5){
                  ids.push(el.id)
                }
                if(el.type==9 || el.type == 2){
                    contBox3.push(el)
                }
            })
            this.moduleList1 = this.moduleList;
            this.moduleList2 = [];
            this.modalId1 = this.moduleList1[0].id
            this.getTeacher(ids)
            this.getCourseList(this.modalId1,'1')
            this.getModuleData(contBox3);
            this.getHeadData(this.moduleList1);
        }
      });
    },
    // 获取 创新思维与创新方法 列表
    getCourseList(id,num){
        this.$axios.post(`/v1/home/moduleData`,{id:id}).then(res=>{
          if(num==1){
              this.courseList1 = res.data.data
            }else{
              this.courseList2 = res.data.data
            }
        })
    },
    // 获取 大师来了 列表
    // getTeacher(id){
    //     this.$axios.post(`/v1/home/moduleData`,{id:id}).then(res=>{
    //         let data = []
    //         if(res.data.length>4){
    //             data = res.data.splice(0,4)
    //         }else{
    //             data = res.data
    //         }
    //         data.forEach(el=>{
    //           el.course=[]
    //           el.honor=[]
    //         })
    //         this.teacherList = data
    //         this.getTeacherDetail(this.teacherList[0])
    //     })
    // },
    async getTeacher(teacherDataIDs) {
      console.log(teacherDataIDs,'teacherDataIDs');
      let promises = [];
      for (let i = 0; i < teacherDataIDs.length; i++) {
        let promise = this.$axios.post(`/v1/home/moduleData`, { id: teacherDataIDs[i] })
          .then(res => {
            let data = res.data.length > 4 ? res.data.slice(0, 4) : res.data;
            data.forEach(el => {
              el.course = [];
              el.honor = [];
            });
            return data; // 返回处理后的数据
          });
        promises.push(promise);
      }
      try {
        const results = await Promise.all(promises); // 等待所有请求完成
        this.teacherList = results
        this.getTeacherDetail(this.teacherList); // 调用getTeacherDetail，传入完整的teacherList
      } catch (error) {
        console.error('Error fetching teacher data:', error);
      }
    },
    getTeacherDetail(item) {
      for (let i = 0; i < item.length; i++) {
        this.showTeacher = item[i];
        this.$axios
        .post(`/v1/home/teacherTag`, { teacher_id: item[i][0].teacher_id })
        .then((res) => {
          if (res.code == 0) {
            this.showTeacher.course = res.data.course;
            this.showTeacher.honor = res.data.honor;
          }
        });
      }
    },
    // getTeacherDetail(item){
    //   this.showTeacher = item
    //   this.$axios.post(`/v1/home/teacherTag`,{teacher_id:item.teacher_id}).then(res=>{
    //     if(res.code==0){
    //       this.showTeacher.course = res.data.course
    //       this.showTeacher.honor = res.data.honor
    //       console.log(this.showTeacher)
    //     }
    //   })
      
    // },
    //获取各模块数据
    async getModuleData(moduleData) {
      let pre_page = undefined
      this.contDataInfo = moduleData;
    //   if (this.contDataInfo <= 0) {
    //     this.loadState = false;
    //     setTimeout(() => {
    //       this.loadState1 = false;
    //     }, 1000);
    //   }
      for (let i = 0; i < moduleData.length; i++) {
        if (moduleData[i].style_id === 6) {
          pre_page = 12
        } else {
          pre_page = undefined
        }
        if (moduleData[i].id == 503 || moduleData[i].id == 504 || moduleData[i].id == 510) {
          pre_page = 4
        }
        let res = await this.$axios.post(`/v1/home/moduleData`, {
          id: moduleData[i].id,pre_page: pre_page
        });

        for (let i = 0; i < this.contDataInfo.length; i++) {
          if (res.data.total) {
            for (let o = 0; o < res.data.data.length; o++) {
              if (res.data.data[o].module_id == this.contDataInfo[i].id) {
                if (this.contDataInfo[i].list) {
                  this.$set(this.contDataInfo[i].list, o, res.data.data[o]);
                } else {
                  this.$set(this.contDataInfo[i], "list", []);
                  this.$set(this.contDataInfo[i].list, o, res.data.data[o]);
                }
              }
            }
          } else {
            for (let o = 0; o < res.data.length; o++) {
              if (res.data[o].module_id == this.contDataInfo[i].id) {
                if (this.contDataInfo[i].list) {
                  this.$set(this.contDataInfo[i].list, o, res.data[o]);
                } else {
                  this.$set(this.contDataInfo[i], "list", []);
                  this.$set(this.contDataInfo[i].list, o, res.data[o]);
                }
              }
            }
          }
        }
        this.loadState = false;
        setTimeout(() => {
          this.loadState1 = false;
        }, 1000);
        // this.loading.close();
      }
      
    },
    
    //获取网站信息
    getWebsiteInfo() {
      // 判断如果是qnapp没有用户信息就接口加载完在显示页面
      if (this.$route.query.source == 'qnapp') {
        if (JSON.parse(localStorage.getItem('userInfo'))) {
          this.isLoad = true
        } else {
          this.isLoad = false
        }
      } else {
        this.isLoad = true
      }
      this.$axios.post(`/v1/websiteInfo`, { is_pc: 2 }).then((res) => {
        this.bottomInfo = res.data.site_info;
        if (JSON.parse(localStorage.getItem('auth'))) {
          this.comAuth = true
        } else {
          this.comAuth = false
          if (this.bottomInfo.id == 106) {
            if (this.$route.query.source == 'qnapp') {
              this.logBtnGrjy()
            }
          }
        }
        localStorage.setItem("siteInfo", JSON.stringify(res.data.site_info));
        localStorage.setItem(
          "navigation",
          JSON.stringify(res.data.navigation)
        );
        this.logo = res.data.site_info.site_logo;
        this.menuList = res.data.navigation; //获取金刚区菜单
        document.getElementById("titleName").innerText =
          res.data.site_info.name;
        //  this.getMeat();
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.m-index {
  background-color: #FFFFFF;
}
.banner_cont {
  background: #fff;
  box-sizing: border-box;
  width: 100%;
  .swiper_cont {
    width: 100%;
    height: 320px;
    .m-banner {
      width: 100%;
      img {
        width: 100%;
        height: 320px;
      }
    }
  }
  .menu_cont {
    margin-top: 44px;
    ul {
      justify-content: center;
      a {
        flex: 1;
      }
      li {
        p.icon {
          width: 96px;
          height: 96px;
          margin: 0 auto;
          img {
            width: 100%;
            height: 100%;
          }
        }
        p.text {
          margin-top: 12px;
          font-size: 28px;
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          color: #333333;
          text-align: center;
        }
      }
      li:nth-child(4n) {
        margin-right: 0;
      }
    }
  }
}
.menu {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 20px;
  padding: 52px 20px 58px 20px;
  border-bottom: 1px solid #f5f5f5;
  background-color: #fff;
  .menu-link {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: calc((100% - 40px) / 3);
    box-sizing: border-box;
    // width: 120px;
    .menu-img {
      display: block;
      width: 80px;
      height: 80px;
      margin-bottom: 32px;
    }
    .menu-title {
      font-weight: 500;
      font-size: 24px;
      color: #333333;
      line-height: 34px;
      text-align: center;
    }
  }
}
.container_cont_data {
  // margin-top: 20px;
  .jx-teacher-bg {
    height: auto;
    padding-bottom: 30px;
    background: url("~@/assets/m/zgwt/jxbg.png") no-repeat;
    background-size: 100% 100%;
    background-position: center top;
    padding-top: 80px;
    .jx-title-img {
      display: block;
      height: 60px;
      width: auto;
    }

  }
  .cont_box {
    background: url("~@/assets/m/zgwt/gzs-bg.png") no-repeat;
    background-size: 100% 40%;
    background-position: top;
  }
  .cont_item {
    box-sizing: border-box;
    padding: 66px 32px;
    .title_cont_info {
      justify-content: center;
      p.text {
        font-family: AlimamaShuHeiTi, AlimamaShuHeiTi;
        font-weight: bold;
        font-size: 36px;
        color: #333333;
        line-height: 44px;
        text-align: center;
        position: relative;
        display: block;
        // &::before {
        //   content: "";
        //   display: block;
        //   position: absolute;
        //   left: -16px;
        //   top: 50%;
        //   transform: translateY(-50%);
        //   width: 8px;
        //   height: 4px;
        //   background: #333333;
        //   z-index: 99;
        // }
        // &::after {
        //   content: "";
        //   display: block;
        //   position: absolute;
        //   right: -16px;
        //   top: 50%;
        //   transform: translateY(-50%);
        //   width: 8px;
        //   height: 4px;
        //   background: #333333;
        //   z-index: 99;
        // }
      }
    }
  }
  // 创新思维与方法
  .cont1 {
    background: url("~@/assets/m/zgwt/zgbg.png") no-repeat;
    background-size: 100% 100%;
    background-position: center top;
    height: 1100px;
    .tab_cont_list {
      margin-top: 56px;
      ul {
        display: flex;
        flex-wrap: nowrap;
        overflow-x: auto;
        li {
          flex: none;
          height: 72px;
          line-height: 72px;
          padding: 0 32px;
          margin-right: 24px;
          font-size: 28px;
          background: rgba(255,255,255,0.2);
          color: #fff;
          border-radius: 6px;
        }
        li.active {
          background: #376CEC;
          color: #fff;
        }
        li:last-child {
          margin-right: 0;
        }
      }
    }
    .course_list {
      margin-top: 18px;
      ul {
        display: flex;
        flex-wrap: wrap;
        gap: 26px;
        li {
          margin-bottom: 26px;
          width: 330px;
          background: #FFFFFF;
          box-shadow: 0px 2px 6px 0px rgba(219,219,219,0.5);
          border-radius: 8px;
          p.img {
            width: 330px;
            height: 200px;
            img {
              width: 100%;
              height: 100%;
              border-radius: 5px 5px 0px 0px;
            }
          }
          p.text {
            height: 36px;
            margin: 20px;
            // padding: 20px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 26px;
            color: #333333;
            line-height: 36px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            overflow: hidden;
          }
        }
      }
    }
    .zg-title-img {
      display: block;
      height: 60px;
      width: auto;
    }
  }
  // 大师来了
  .teacher_cont_box {
    background: transparent;
    margin-top: 24px;
    position: relative;
    .teacher_list_cont {
      margin-top: 24px;
      .teacherSwiper {
        .slide_item {
          box-sizing: border-box;
          width: 100%;
          padding: 0 32px;
        }
      }
    }
    .jx-teacher-card {
      position: relative;
      border-radius: 28px;
      background: url("~@/assets/m/zgwt/jxconbg.png") no-repeat;
      background-size: 100% 100%;
      background-position: center center;
      padding: 44px 36px 32px;
      height: 900px;
      overflow: hidden;
    }
    .jx-teacher-card-top {
      position: relative;
      height: 360px;
      padding-left: 290px;
      display: flex;
      align-items: center;
    }
    .jx-teacher-avatar {
      position: absolute;
      left: 0;
      top: 0;
      width: 350px;
      height: 452px;
    }
    .jx-teacher-avatar img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
    .jx-teacher-title {
      width: 100%;
      text-align: center;
    }
    .jx-teacher-name {
      font-family: AlimamaShuHeiTi, AlimamaShuHeiTi;
      font-weight: bold;
      font-size: 48px;
      color: #2F7BFF;
      line-height: 56px;
    }
    .jx-teacher-card-bottom {
      margin-top: -12px;
      // background: rgba(14, 35, 69, 0.85);
      border-radius: 22px;
      padding: 20px 28px;
    }
    .jx-teacher-desc {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 26px;
      color: rgba(255, 255, 255, 0.86);
      line-height: 44px;
      white-space: pre-line;
      transform: translateY(101px);
    }
    .jx-more-btn {
      width: 168px;
      height: 56px;
      margin: 40px auto 0;
      background: #ffffff;
      border-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 10px;
    }
    .jx-more-btn span {
      font-family: PingFangSC, PingFang SC;
      font-size: 24px;
      color: #2F7BFF;
      line-height: 56px;
    }
    .jx-more-arrow {
      width: 28px;
      height: 28px;
      margin-top: 2px;
    }
  }
  // 创新工作室
  .cont2 {
    .course_cont_list {
      margin-top: 36px;
      ul {
        display: flex;
        flex-wrap: wrap;
        gap: 26px;
        li {
          margin-bottom: 26px;
          width: 330px;
          background: #FFFFFF;
          box-shadow: 0px 2px 6px 0px rgba(219,219,219,0.5);
          border-radius: 8px;
          p.img {
            width: 330px;
            height: 200px;
            img {
              width: 100%;
              height: 100%;
              border-radius: 5px 5px 0px 0px;
            }
          }
          p.text {
            height: 36px;
            margin: 20px;
            // padding: 20px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 26px;
            color: #333333;
            line-height: 36px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            overflow: hidden;
          }
        }
      }
    }
  }
  .gk-section {
    padding: 88px 32px 64px;
    background: url("~@/assets/m/zgwt/gkbg.png") no-repeat;
    background-size: 100% 100%;
    background-position: center center;
  }
  .gk-title {
    display: flex;
    justify-content: center;
  }
  .gk-title-img {
    display: block;
    height: 64px;
    width: auto;
  }
  .gk-grid {
    margin-top: 56px;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 24px;
  }
  .gk-card {
    border-radius: 16px;
    overflow: hidden;
    background: #ffffff;
  }
  .gk-card-top {
    position: relative;
    height: 220px;
    background: #000;
  }
  .gk-card-top::after {
    content: "";
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.35);
  }
  .gk-card-img {
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
  }
  .gk-card-title {
    position: absolute;
    left: 24px;
    right: 24px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 1;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 26px;
    color: #ffffff;
    line-height: 36px;
    text-align: center;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }
  .gk-card-body {
    padding: 24px;
  }
  .gk-row + .gk-row {
    margin-top: 18px;
  }
  .gk-label {
    display: block;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 22px;
    color: #666666;
    line-height: 30px;
  }
  .gk-value {
    display: block;
    margin-top: 6px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 26px;
    color: #333333;
    line-height: 34px;
  }
  .gk-status {
    margin-top: 18px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 26px;
    line-height: 34px;
  }
  .gk-status.is-going {
    color: #69A85D;
  }
  .gk-status.is-wait {
    color: #F3A23A;
  }
  .gk-status.is-end {
    color: #999999;
  }
  .gk-foot {
    margin-top: 14px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 22px;
    color: #333333;
    line-height: 30px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
  }
  .wdy_bg {
    background: url("~@/assets/m/zgwt/wdybg.png") no-repeat;
    background-size: 100% 100%;
    background-position: 100% 100%;
  }
  .news_bg {
    background: url("~@/assets/m/zgwt/xwbg.png") no-repeat;
    background-size: 100% 100%;
    background-position: center center;
  }
  .yx_bg {
    background: url("~@/assets/m/zgwt/yxbg.png") no-repeat;
    background-size: 100% 100%;
    background-position: center center;
  }
  .yx-title-img {
    display: block;
    height: 60px;
    width: auto;
  }
  .wdy-title-img {
    display: block;
    height: 60px;
    width: auto;
  }
  .xw-title-img {
    display: block;
    height: 60px;
    width: auto;
  }
}
.line_img {
  img {
    width: 100%;
    display: block;
  }
}
.last_img {
  margin-top: -20px;
}

.deep_cont_box {
  width: 100%;
  background: #EDEDED;
  box-sizing: border-box;
  padding: 44px 32px;
  text-align: center;
  p {
    margin: 0;
    font-size: 24px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 40px;
  }
  .support {
    opacity: 0.8;
  }
  .copyright,
  .rights,
  .icp {
    opacity: 0.6;
  }
}

::-webkit-scrollbar {
  width: 0;
}
::-webkit-scrollbar {
  width: 0;
}
/* 隐藏 IE 和 Edge 浏览器的滚动条 */
::-ms-scrollbar {
  width: 0;
}
.flex {
  display: flex;
  align-items: center;
}
.cursor {
  cursor: pointer;
}
.overflow_o {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.overflow_2 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.overflow_3 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
.overflow_4 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
.modal-content {
  padding: 38px 28px;
  padding-right: 0;
  background-color: #fff;
  &.live {
    padding-right: 32px;
    padding-top: 60px;
    // margin-bottom: 52px;
    padding-bottom: 56px;
    background-image: url('~@/assets/m/zgwt/zbbg.png');
    background-position: 100% 100%;
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
  .zb-title-img {
    display: block;
    height: 60px;
    width: auto;
  }
  .modal-title {
    font-size: 36px;
    color: #333;
    font-weight: 600;
    margin-bottom: 28px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .more {
      padding-right: 40px;
      font-size: 28px;
      color: #999;
      position: relative;
      &::before {
        content: "";
        display: block;
        width: 40px;
        height: 40px;
        background: url(~@/assets/arrows.png) no-repeat center center;
        background-size: 100%;
        transform: rotate(-90deg);
        position: absolute;
        top: 0;
        right: 0;
      }

      margin-right: 30px;
    }
  }
  .modal-list {
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;
    padding: 0 0 10px 10px;
    &::-webkit-scrollbar {
      //隐藏滚动条
      display: none;
    }
    .modal-list-info {
      flex-shrink: 0;
      width: 386px;
      height: 454px;
      background: #fff;
      box-shadow: 0px 0px 10px 0px rgba(0, 12, 40, 0.14);
      border-radius: 7px;
      overflow: hidden;
      margin-right: 28px;
      &.active {
        height: 360px;
      }
    }
    .list-info-img {
      width: 100%;
      height: 214px;
    }
    .list-info-content {
      padding: 10px 20px 0;
    }
    .info-content-title {
      height: 74px;
      font-size: 28px;
      color: #333;
      line-height: 37px;
    }
    .info-sub-title {
      font-size: 24px;
      color: #999;
      -webkit-line-clamp: 1;
    }
    .info-content-subtitle {
      font-size: 24px;
      color: #999;
    }
    .info-content-price {
      padding: 28px 4px 0;
      border-top: 1px solid #e5e5e5;
      margin-top: 27px;
      font-size: 30px;
      color: #cd1b14;
      font-weight: bold;
    }
  }
  &.lecturer {
    background-color: #f7f7f7;
    .lecturer-card {
      box-sizing: border-box;
      width: 100%;
      padding: 28px;
      background-color: #fff;
      overflow: hidden;
      position: relative;
    }
    .lecturer-img {
      width: 158px;
      height: 208px;
      border-radius: 8px;
      float: left;
      object-fit: cover;
    }
    .lecturer-content {
      width: 340px;
      float: left;
      margin-left: 20px;
    }
    .lecturer-title {
      display: flex;
      align-items: center;
      .marks {
        margin: 0 0 0 10px;
        .mark {
          padding: 8px;
          background: rgba(255, 195, 11, 0.14);
          font-size: 24px;
          color: #f5a623;
        }
      }
    }
    .lecturer-name {
      font-size: 28px;
      color: #333;
    }
    .lecturer-intro {
      padding-top: 20px;
      max-height: 70px;
      line-height: 35px;
      font-size: 26px;
      color: #999;
      //多行省略号
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
    }
    .lecturer-btn {
      width: 128px;
      height: 42px;
      line-height: 42px;
      border: 1px solid #254ed4;
      border-radius: 6px;
      text-align: center;
      font-size: 24px;
      color: #254ed4;
      position: absolute;
      right: 20px;
      bottom: 20px;
    }
  }
  &.xilie {
    padding-left: 0;
    padding-right: 0;
    .modal-title {
      padding-left: 28px;
    }
  }
  .xilie-list-info {
    padding: 28px;
    border-bottom: 1px solid #f5f5f5;
    .xilie-img {
      width: 308px;
      height: 200px;
      float: left;
      position: relative;
      &::before {
        content: "";
        display: block;
        width: 294px;
        height: 200px;
        background: linear-gradient(
          180deg,
          rgba(195, 204, 255, 0.14) 0%,
          rgba(125, 134, 168, 0.17) 45%,
          rgba(72, 82, 103, 0.3) 100%
        );
        box-shadow: 0px 1px 0px 0px #f5f5f5;
        border-radius: 6px;
        border-image: linear-gradient(
            180deg,
            rgba(159, 159, 159, 0),
            rgba(72, 82, 103, 0.07)
          )
          1 1;
        position: absolute;
        left: 0;
        right: 0;
        margin: 6px auto;
        z-index: 1;
      }
      &::after {
        content: "";
        display: block;
        width: 274px;
        height: 200px;
        background: linear-gradient(
          180deg,
          rgba(255, 255, 255, 0) 0%,
          rgba(72, 82, 103, 0.13) 100%
        );
        box-shadow: 0px 1px 0px 0px #f5f5f5;
        border-radius: 6px;
        border-image: linear-gradient(
            180deg,
            rgba(159, 159, 159, 0),
            rgba(72, 82, 103, 0.06)
          )
          1 1;
        position: absolute;
        left: 0;
        right: 0;
        margin: 12px auto;
        z-index: 0;
      }
      img {
        width: 100%;
        height: 100%;
        border-radius: 6px;
        position: absolute;
        left: 0;
        top: 0;
        z-index: 2;
      }
    }
    .xilie-con {
      width: 356px;
      float: left;
      margin-left: 20px;
      position: relative;
    }
    .xilie-name {
      height: 80px;
      line-height: 40px;
      font-size: 28px;
      color: #333;
      //多行省略号
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
    }
    .xilie-teachers {
      padding-top: 10px;
      font-size: 24px;
      color: #999;
    }
    .xilie-intro {
      font-size: 24px;
      color: #999;
      overflow: hidden !important;
      text-overflow: ellipsis !important;
      -webkit-line-clamp: 2;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      white-space: normal;
      word-wrap: break-word;
      max-height: 60px;
    }
    .xilie-price {
      padding-top: 28px;
      font-size: 32px;
      font-weight: bold;
      color: #cd1b14;
      .unit {
        font-size: 24px;
      }
    }
  }
  &.style_8 {
    padding-right: 28px;
  }
  .active-list {
    .active-info {
      box-sizing: border-box;
      padding: 27px 32px;
      box-shadow: 0px 0px 14px 1px rgba(0, 12, 40, 0.14);
      display: flex;
      justify-content: space-between;
      border-radius: 6px;
      overflow: hidden;
      margin-bottom: 20px;
    }
    .active-img {
      width: 289px;
      height: 163px;
      border-radius: 6px;
    }
    .active-con {
      width: 320px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
    .active-name {
      font-size: 32px;
      color: #333;
    }
    .active-sub-title {
      height: 36px;
      font-size: 14px;
      color: #999;
      line-height: 36px;
      -webkit-line-clamp: 1;
    }
  }
}
// 公开考试样式
.comm-exam-cont {
  ul {
    width: 96%;
  }
  li {
    margin-top: 20px;
    background: #fff;
    box-shadow: 0px 0px 14px 1px rgba(0, 12, 40, 0.14);
    border-radius: 12px;
    box-sizing: border-box;
    padding: 30px;
    p.exam_name {
      font-size: 32px;
      margin-bottom: 10px;
    }
    div.time_ {
      p {
        font-size: 24px;
        color: #666;
        margin-bottom: 10px;
      }
    }
    .down_num {
      font-size: 24px;
      color: #666;
    }
    div.btn {
      display: inline-block;
      background: #254ed4;
      padding: 10px 20px;
      margin-top: 20px;
      cursor: pointer;
      border-radius: 10px;
      color: #fff;
      font-size: 28px;
    }
  }
}
.live-swiper {
  width: 100%;
  margin-bottom: 20px;
  .live-slide-content {
    width: 100%;
    box-sizing: border-box;
    cursor: pointer;
    margin-top: 52px;
  }
}
.live-banner {
  position: relative;
  width: 100%;
  height: 400px;
  border-radius: 12px 12px 0px 0px;
  overflow: hidden;
  // margin-bottom: 28px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.1);
  .live-banner-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .live-banner-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 36px 32px;
    background: linear-gradient(to bottom, rgba(255,255,255,0.2) 0%, rgba(0,0,0,0.2) 100%);
  }
  .live-banner-left {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    .live-banner-title {
      font-size: 40px;
      font-weight: bold;
      color: #333333;
      line-height: 56px;
      margin-bottom: 20px;
      text-shadow: 0 2px 4px rgba(255,255,255,0.9);
    }
    .live-banner-target {
      display: inline-block;
      padding: 10px 20px;
      background: #376CEC;
      color: #fff;
      font-size: 24px;
      border-radius: 6px;
      line-height: 34px;
      align-self: flex-start;
    }
  }
  .live-banner-right {
    display: flex;
    align-items: flex-start;
    .live-teacher-info {
      background: rgba(55, 108, 236, 0.85);
      border-radius: 40px;
      padding: 20px 24px;
      text-align: center;
      min-width: 140px;
      box-shadow: 0 2px 8px rgba(0,0,0,0.15);
      .live-teacher-name {
        font-size: 26px;
        color: #fff;
        font-weight: 600;
        margin-bottom: 10px;
        line-height: 36px;
      }
      .live-teacher-honor {
        font-size: 20px;
        color: #fff;
        line-height: 28px;
        opacity: 0.95;
        white-space: normal;
        word-break: break-all;
      }
    }
  }
}
.live-bottom-info {
  padding: 0 4px;
  background: rgba(0,0,0,0.6);;
  padding: 10px;
  .live-status {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    .live-status-icon {
      display: inline-block;
      width: 36px;
      height: 36px;
      background: url(~@/assets/m/zgwt/live-now-ico.png) no-repeat center;
      background-size: contain;
      margin-right: 14px;
      flex-shrink: 0;
    }
    .live-status-text {
      font-size: 26px;
      margin-right: 30px;
      font-weight: 500;
      &.is-live {
        color: #366CEC;
      }
      &.is-not-live {
        color: #fff;
      }
    }
    .live-status-time {
      padding: 6px 14px;
      font-size: 26px;
      border-radius: 6px;
      white-space: nowrap;
      color: #fff;
      font-weight: 500;
    }
  }
  .live-course-title {
    font-size: 30px;
    color: #fff;
    line-height: 42px;
    margin-bottom: 16px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    font-weight: 500;
  }
  .live-lecturer-name {
    font-size: 28px;
    color: #bbb;
    line-height: 36px;
  }
}
.live-list {
  height: 154px;
  background-color: #f5f5f5;
  margin-top: 45px;
  .list-info {
    display: block;
    box-sizing: border-box;
    width: 100%;
    padding: 33px 20px 28px;
  }
  .list-info-title {
    padding-left: 44px;
    background: url(~@/assets/clock-ico.png) no-repeat left center;
    background-size: auto 24px;
    font-size: 22px;
    color: #999;
  }
  .list-info-lecturer {
    font-size: 24px;
    color: #999;
    margin-left: 28px;
  }
  .list-info-name {
    box-sizing: border-box;
    width: 490px;
    height: 45px;
    line-height: 45px;
    padding-left: 44px;
    margin-top: 24px;
    font-size: 28px;
    color: #333;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    position: relative;
    &::before {
      content: "";
      display: block;
      width: 1px;
      height: 45px;
      background-color: #ccc;
      position: absolute;
      top: 0;
      left: 12px;
    }
  }
}
// 广告位
.vert_box {
  padding: 76px 0 0;
  background: #fff;
  margin-left: -28px;
  img {
    width: 100%;
    max-height: 200px;
    object-fit: cover;
  }
}
.title_cont_info {
  justify-content: center;
  p.text {
    font-family: AlimamaShuHeiTi, AlimamaShuHeiTi;
    font-weight: bold;
    font-size: 36px;
    color: #333333;
    line-height: 44px;
    text-align: center;
    position: relative;
    display: block;
    // &::before {
    //   content: "";
    //   display: block;
    //   position: absolute;
    //   left: -16px;
    //   top: 50%;
    //   transform: translateY(-50%);
    //   width: 8px;
    //   height: 4px;
    //   background: #333333;
    //   z-index: 99;
    // }
    // &::after {
    //   content: "";
    //   display: block;
    //   position: absolute;
    //   right: -16px;
    //   top: 50%;
    //   transform: translateY(-50%);
    //   width: 8px;
    //   height: 4px;
    //   background: #333333;
    //   z-index: 99;
    // }
  }
}

.more_btn {
  width: 168px;
  height: 56px;
  background: #FFFFFF;
  border-radius: 8px;
  justify-content: center;
  margin-top: 60px;
  span {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 24px;
    color: #366CEC;
    line-height: 56px;
    text-align: center;
  }
  img {
    width: 28px;
    height: 32px;
  }
}
.flex-center {
  display: flex;
  justify-content: center;
}
</style>
